import type { FormState } from "./types";

export const INITIAL_STATE: FormState = {
  componentFields: {},
  componentFieldErrors: {},
  componentFieldMessages: {},
  parentId: null,
  tools: [],
  skills: [],
  semesters: [],
  subjects: [],
  editingSection: null,
  editingId: null,
  editingParentId: null,
  formFields: {},
  formFieldErrors: {},
  formFieldMessages: {},
  expandedSemesterIds: new Set(),
  expandedCategoryIds: new Set(),
  selectedSemesterFilter: null,
};

export const DELETE_LABELS: Record<string, { title: string; description: string }> = {
  category: { title: "Delete Category", description: "This will also delete all items under this category." },
  categoryItem: { title: "Delete Category Item", description: "This will delete this item." },
  semester: { title: "Delete Semester", description: "This will delete all categories and subjects in this semester." },
  subject: { title: "Delete Subject", description: "This will delete this subject and its electives." },
};
